import {
  Box,
  Button,
  IconButton,
  InputBase,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { SearchProcessModal } from "../components/SearchProcessModal";
import GroupsIcon from "@mui/icons-material/Groups";
import { useNavigate } from "react-router-dom";
import { RoutesConfig } from "../router/types";
import LayoutFixHome from "../components/LayoutFixHome";
import SearchIcon from "@mui/icons-material/Search";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import UsersViewer from "../components/UsersViewer";
import { getAllUsers } from "../services/clientService";

export const Usuarios: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showProcessSearchModal, setProcessSearchModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [users, setUsers] = useState<{ users: any[]; count: number }>({
    users: [],
    count: 0,
  });

  const fetchUsers = async () => {
    try {
      const data = await getAllUsers();
      setUsers(data);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <>
      <LayoutFixHome>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: "29px",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
              marginTop: {
                sm: "75px",
                xs: "75px",
                md: 0,
              },
            }}
          >
            <GroupsIcon sx={{ color: "#0A0C33", fontSize: "36px" }} />
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", color: "#0A0C33" }}
            >
              Usuários
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#5C5C5C", marginTop: "10px" }}
            >
              {users.count} usuário(s) cadastrado(s)
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginTop: {
                sm: "75px",
                xs: "75px",
                md: 0,
              },
            }}
          >
            {!isMobile && (
              <Paper
                component="form"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "20px",
                  padding: "2px 10px",
                  width: isMobile ? "100%" : 300,
                  backgroundColor: "#F0F0F0",
                  marginTop: isMobile ? "8px" : 0,
                }}
                onSubmit={(e) => e.preventDefault()}
              >
                <IconButton
                  type="submit"
                  sx={{ p: "10px", color: "#909090" }}
                  aria-label="search"
                >
                  <SearchIcon />
                </IconButton>
                <InputBase
                  placeholder="Buscar usuário por grupo"
                  sx={{ ml: 1, flex: 1, color: "#000000" }}
                  inputProps={{ "aria-label": "buscar processo" }}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </Paper>
            )}
            <Button
              sx={{
                textTransform: "none",
                backgroundColor: "#326AFD",
                color: "#FFFFFF",
                borderRadius: "27px",
                fontSize: "16px",
                fontWeight: "700",
                width: isMobile ? "auto" : "202px",
              }}
              onClick={() => navigate(RoutesConfig.CADASTRARUSUARIO.path)}
            >
              <AddCircleOutlineRoundedIcon sx={{ marginRight: "5px" }} />
              {isMobile ? "Add Usuário" : "Adicionar Usuário"}
            </Button>
          </Box>
        </Box>
        <UsersViewer searchText={searchText} />
        <SearchProcessModal
          open={showProcessSearchModal}
          onClose={() => setProcessSearchModal(false)}
        />
      </LayoutFixHome>
    </>
  );
};
